import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { Translations } from '@volt/shared/services/translations.types';
import { IT } from '../../../../../models/volt-account';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { BaseFilterForm } from '@volt/shared/components/form-fields/base-filter-form';

@Component({
  selector: 'account-it',
  templateUrl: './account-it.component.html',
  styles: [
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountItComponent extends BaseFilterForm<IT> implements OnInit {
  @Input() translations: Translations;

  _it: IT;
  @Input() set it(i: IT) {
    this._it = i;
    this.controls.email.setValue(i?.email);
    this.controls.phone.setValue(i?.phone);
  }

  @Input() set disabled(d: boolean) {
    if(d) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }

  constructor(private readonly _fb: UntypedFormBuilder) {
    super();
    this.initForm();
  }

  initForm(): void {
    this.form = this._fb.group({
      email: ['', [Validators.email, Validators.required]],
      phone: ['', Validators.required]
    })
  }

  get invalid() {
    return this.form.invalid;
  }

  get value() {
    return {
      email: this.controls.email.value,
      phone: this.controls.phone.value
    } as IT;
  }
}
